import React from 'react'
import PropTypes from 'prop-types'
import Line from './ProgressBarLine'
import Step from './ProgressBarStep'
import { fillColor, emptyColor } from './ProgressBarConstants'
import { withResponsive } from '../Grid'

ProgressBar.propTypes = {
  currentStep: PropTypes.number,
  steps: PropTypes.array,
  vertical: PropTypes.bool
}

function ProgressBar({ currentStep, steps, vertical = false }) {
  return (
    <div
      style={{
        display: 'flex',
        position: 'relative',
        flexDirection: vertical ? 'column' : 'row',
        marginLeft: vertical ? 0 : 50,
        marginRight: vertical ? 0 : 50
      }}
    >
      {steps.map(({ Icon, label }, index) => (
        <React.Fragment key={index}>
          <Step
            key={index}
            Icon={Icon}
            label={label}
            backgroundColor={currentStep > index ? fillColor : emptyColor}
            vertical={vertical}
          />
          {index < steps.length - 1 ? (
            <Line
              backgroundColor={index < currentStep ? fillColor : emptyColor}
              vertical={vertical}
            />
          ) : null}
        </React.Fragment>
      ))}
    </div>
  )
}

ResponsiveProgressBar.propTypes = {
  breakpoint: PropTypes.string,
  ...ProgressBar.propTypes
}

function ResponsiveProgressBar({ breakpoint, ...props }) {
  return <ProgressBar {...props} vertical={breakpoint === 'mobile'} />
}

export default withResponsive(ResponsiveProgressBar)

export { ProgressBar }
